var exports = {};
// we can't use just `it == null` since of `document.all` special case
// https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot-aec
exports = function (it) {
  return it === null || it === undefined;
};
export default exports;